<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-toolbar fixed app clipped-left :color="$utils.isMobile() ? '#01A6BE' : '#01AFC8'">
        <div class="icon-container" :class="{'pl-3': $utils.isNotMobile()}">
            <v-btn @click="toggleNavigation" fab flat class="t-btn">
                <v-icon color="white">menu</v-icon>
            </v-btn>
            <div style="height: calc(100% - 10px);max-height: 44px;">
                <img src="@/assets/logo.png" alt="avatar" style="height: 100%">
                <span class="logo-text" v-if="$utils.isNotMobile()">Reporting</span>
            </div>
        </div>
        <ToolbarActiveProject></ToolbarActiveProject>
        <v-spacer></v-spacer>
        <LanguageSelector></LanguageSelector>
        <UserMenu></UserMenu>
    </v-toolbar>
</template>
<script>
import LanguageSelector from './LanguageSelector.vue'
import UserMenu from './UserMenu.vue'
import ToolbarActiveProject from './ToolbarActiveProject.vue'

export default {
    name: 'AppToolbar',
    components: { LanguageSelector, UserMenu, ToolbarActiveProject },
    methods: {
        redirectTo (url) {
            this.$router.push(url)
        },
        toggleNavigation () {
            this.$store.dispatch(this.$actionTypes.TOGGLE_NAVIGATION)
        }
    }
}
</script>
<style scoped>
    .icon-container {
        background-color: #01A6BE;
        display: flex;
        align-items: center;
        height: 100%;
        width: 300px;
    }

    .t-btn {
        height: 30px;
        width: 30px;
        /*margin-top: 25px;*/
    }

    .logo-text {
        font-weight: bold;
        font-size: 16px;
        color: #fff;
    }

    /deep/ .v-toolbar__content {
        padding: 0;
    }
</style>
